<script setup>
import { computed } from 'vue'

const ServiceOrderStatus = {
  Pending: 0,
  PendingRevoke: 1,
  Active: 2,
  Rejected: 3,
  Revoked: 4,
}

const props = defineProps({
  status: {
    type: Number,
    default: null,
  },
})

const classes = computed(() => {
  switch (props.status) {
    case ServiceOrderStatus.Pending:
    case ServiceOrderStatus.PendingRevoke:
      return 'bg-amber-600'
    case ServiceOrderStatus.Active:
      return 'bg-green-700'
    case ServiceOrderStatus.Rejected:
    case ServiceOrderStatus.Revoked:
      return 'bg-red-600'
    default:
      return 'bg-microsoft-blue-default'
  }
})
</script>

<template>
  <span
    class="inline-flex text-white px-1.5 text-xs rounded font-medium text-center items-center"
    :class="classes"
  >
    <template v-if="typeof status === 'number'">
      {{ $t(`Enums.ServiceOrderStatus.${status}`) }}
    </template>
    <template v-else>
      {{ $t('Enums.ServiceOrderStatus.New') }}
    </template>
  </span>
</template>
